export const pluginID = 'taf-plugin';
export const PARTNER_ORGANISATION_GROUP_ID = 53;
export const ASSOCIATION_COMPANY_TYPE_ID = 34;
export const defaultVoucherTypeID = '27';
export const ASSOCIATION_ENTITY_TYPE = 'association';
export const PROFFESIONAL_ENTITY_TYPE = 'proffesional';
